import RequestHandler from "./request-handler";
class TaskService {
    constructor() {
        this.path = "tasks";
        if (TaskService.instance) {
            return TaskService.instance;
        }
        TaskService.instance = this;
        return this;
    }
    async get(loadOptions) {
        return await RequestHandler.getWithParams(this.path, loadOptions);
    }
    async getById(id) {
        return await RequestHandler.get(`${this.path}/getById`, id);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
    async unreadmessagesinfo() {
        return await RequestHandler.get(`${this.path}/unreadmessagesinfo`);
    }
    async insertWithAttachments(data) {
        return await RequestHandler.post(`${this.path}/insertWithAttachments`, data);
    }
}
const instance = new TaskService();
export default instance;